var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDottedCircularLoader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#4975F3"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.143,
    cy: 2.143,
    r: 2.143,
    fillOpacity: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.143,
    cy: 17.143,
    r: 2.143,
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.927,
    cy: 5.927,
    r: 2.143,
    transform: "rotate(60 16.927 5.927)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.927,
    cy: 13.927,
    r: 2.143,
    fillOpacity: 0.51,
    transform: "rotate(60 2.927 13.927)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.927,
    cy: 13.927,
    r: 2.143,
    fillOpacity: 0.18,
    transform: "rotate(120 16.927 13.927)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.053,
    cy: 6.071,
    r: 2.143,
    fillOpacity: 0.67,
    transform: "rotate(120 3.053 6.071)"
  }))));
}
export default SvgDottedCircularLoader;